import { Injectable } from '@angular/core';
import { ProductService } from './product.service';
import { ContextService } from '@app/core/service/context.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FavoriteService {
  public countFavorites: number = 0;
  private favorisSubject = new BehaviorSubject<number>(0);
  public favoris$ = this.favorisSubject.asObservable();
  public favorisCount = this.favoris$.subscribe((count) => this.countFavorites = count);

  // Service des favoris permettant de gérer le nombre de favoris globalement pour le header
  constructor(private productService: ProductService, private contextService: ContextService) {
  }

  public setCountFavorites(countFavorites: number) {
    this.favorisSubject.next(countFavorites);
    localStorage.setItem("countFavorites", this.countFavorites.toString());
  }

  // On récupère le nombre de favoris et on met à jour la variable countFavorites
  public getCountFavorites() {
    let company = localStorage.getItem("selectedCompany");
    let customer = localStorage.getItem("selectedCustomer");
    if (company && customer) {
      this.productService.getCountFavorites(company, customer,
        this.contextService.fullContext?.order?.code ? this.contextService.fullContext?.order.code : "")
                          .subscribe((nbFavorites) => {
                          this.setCountFavorites(nbFavorites);
                        });
    }
    else {
      this.countFavorites = 0;
    }
  }

  // On ajoute ou on supprime un favoris puis on met à jour le nombre de favoris
  public addFavorite(productCode: string, add: boolean) {

      this.productService.postFavorite(localStorage.getItem("selectedCompany"),
                                        productCode, add)
      .subscribe((e) => {this.getCountFavorites()});
  }
}
